import { Box, Card, CardContent, CardHeader, Grid2, Typography } from "@mui/material";
import ArrowButton from "@/ui-kit/ArrowButton";
import { RouteTo } from "@routing/RouteMap";
import { useNavigate } from "react-router-dom";

const UserGuidelineWidget = () => {
    const navigate = useNavigate();

    return (
        <Card sx={{ width: "100%", height: "100%", p: 1.5, display: "flex", flexDirection: "column", flex: 1, justifyContent: "space-between" }}>
            <CardHeader title={<Typography variant={"h6"}>Nutzerleitfaden</Typography>} sx={{ pb: 0.5 }} />

            <CardContent>
                <Grid2>
                    <Typography>Schaue Dir unbedingt den Nutzerleitfaden an. Hier findest Du alles, was Du über den ESGbot wissen musst.</Typography>
                </Grid2>
            </CardContent>

            <Box p={1.5}>
                <ArrowButton fullWidth onClick={() => navigate(RouteTo.USER_GUIDE)}>
                    Ansehen
                </ArrowButton>
            </Box>
        </Card>
    );
};

export default UserGuidelineWidget;
